<div class="row">
  <button mat-button mat-dialog-close="cancel" style="float: right !important;" class="circle_button">X</button>
</div>
<!--<div md-dialog-content>-->
<!--  <agm-map [latitude]="latitude" [longitude]="longitude" [scrollwheel]="false" [zoom]="zoom">-->
<!--    <agm-marker [latitude]="latitude" [longitude]="longitude"></agm-marker>-->
<!--  </agm-map>-->
<!--  <div class="go_button sm square green wide" (click)="navigate()">-->
<!--    <i class="icon-location"> Navigate</i>-->
<!--  </div>-->
<!--</div>-->

